import styled from 'styled-components';

interface QualityInfoContainerProps {
  $layout?: 'row' | 'column';
}

export const QualityInfoContainer = styled.div<QualityInfoContainerProps>`
  font-size: 10px;
  color: #666;
`;

interface QualityItemProps {
  $layout?: 'row' | 'column';
}

export const QualityItem = styled.div<QualityItemProps>`
  display: flex;
  flex-direction: ${(props) => (props.$layout === 'column' ? 'column' : 'row')};
  align-items: ${(props) =>
    props.$layout === 'column' ? 'flex-start' : 'center'};
  gap: ${(props) => (props.$layout === 'column' ? '2px' : '4px')};
  margin-bottom: ${(props) => (props.$layout === 'column' ? '6px' : '4px')};

  &:last-child {
    margin-bottom: 0;
  }
`;

export const PackingSelectWrapper = styled.div`
  .ant-select {
    .ant-select-arrow {
      border: 1px solid #f88f1f;
      border-radius: 0;
      background-color: transparent;
      right: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 2px 4px;

      .anticon {
        color: #f88f1f;
        font-size: 8px;
      }
    }

    @media (max-width: 600px) {
      .product-card-grid-container & {
        .ant-select-selection-item {
          font-size: 10px;
        }
      }
    }
  }
`;
